export default __webpack_public_path__ + "static/media/brevo.7eb3ae21.png";